import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription, catchError, exhaustMap, map, of, timeout, timer } from 'rxjs';
import { environment } from '../../../environments/environment';

interface StorageStatus { available: boolean; mode: 'local'|'s3'|'unknown'; checked_at?: string; }

/** One monitor per open form; stops polling when the user leaves the page. */
@Injectable()
export class FileStorageStatusService {
  private readonly http = inject(HttpClient);
  private readonly destroy = inject(DestroyRef);
  private polling?: Subscription;
  private generation = 0;
  private revision = 0;
  readonly available = signal(false);
  readonly checking = signal(true);
  readonly mode = signal<StorageStatus['mode']>('unknown');

  watch(project: string | null): void {
    this.polling?.unsubscribe();
    const generation = ++this.generation;
    this.available.set(false); this.checking.set(true);
    if (!project) { this.checking.set(false); return; }
    const url = environment.backendUrl.replace(/\/$/, '') + '/pvt/gb/proyectos/workspace/' + encodeURIComponent(project) + '/storage-status';
    this.polling = timer(0, 15000).pipe(
      exhaustMap(() => { const revision = this.revision; return this.http.get<{data:StorageStatus}>(url).pipe(
        timeout(20000),
        catchError(() => of({data:{available:false,mode:'unknown' as const}})),
        map(result => ({result, revision}))
      );}),
      takeUntilDestroyed(this.destroy)
    ).subscribe(({result, revision}) => {
      if (generation !== this.generation || revision !== this.revision) return;
      const state = result?.data;
      this.available.set(state?.available === true);
      this.mode.set(state?.mode ?? 'unknown');
      this.checking.set(false);
    });
  }

  failed(): void { this.revision++; this.available.set(false); this.checking.set(false); }
}
